import { Component } from "@angular/core";

@Component({
	selector: "app-progress-dots",
	templateUrl: "./progress-dots.component.html",
	styleUrls: ["./progress-dots.component.css"],
	standalone: false,
})
export class ProgressDotsComponent {}
